import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { useApolloClient } from "@apollo/client";
import { ChildPropsFromArray } from "types/commons";
import {
	AllTermsAndConditionsDocument,
	AllTermsAndConditionsQuery,
} from "__generated__/view/terms/graphql/queries.generated";

export type TermsAndConditionsOption = ChildPropsFromArray<AllTermsAndConditionsQuery, "allTermsAndConditions">;

const TermsAndConditionsSelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<TermsAndConditionsOption, Multiple>, "fetchOptions">) => {

	const client = useApolloClient();

	const onFetchOptions = async() => {
		const { data } = await client.query({
			query: AllTermsAndConditionsDocument,
		});

		const options = data?.allTermsAndConditions ?? [];

		return {
			options,
			totalResults: options.length,
		};
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			getOptionLabel={option => option.description || ""}
			renderOption={(props, option) => (
				<li {...props}>
					<div style={{ width: "100%" }}>
						<small style={{ display: "block", whiteSpace: "wrap", width: "100%" }}>
							{option.description}
						</small>
					</div>
				</li>
			)}
			popoverHeight={300}
		/>
	);
};

export default TermsAndConditionsSelect;
